import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

type Lang = 'en' | 'ar';

const STRINGS = {
  en: {
    'hero.kicker':   'Restaurant · Order online',
    'hero.tagline':  'Real food, sent fast.',
    'hero.sub.0':    'Hand-prepared every day.',
    'hero.sub.1':    'Delivery in 25–45 minutes.',
    'hero.sub.2':    'Pickup ready in 15 minutes.',
    'hero.cta.order_delivery': 'Order delivery',
    'hero.cta.order_pickup':   'Order pickup',
    'hero.open_now':          'Open now',
    'hero.closed':            'Currently closed',

    'usp.fresh.title':      'Made fresh',
    'usp.fresh.body':       'Prepared to order — never sitting under a heat lamp.',
    'usp.delivery.title':   'Fast delivery',
    'usp.delivery.body':    'Drivers leave our kitchen the moment it’s ready.',
    'usp.secure.title':     'Safe & verified',
    'usp.secure.body':      'ZATCA Phase-2 compliant invoicing on every order.',

    'categories.title':     'Browse by category',
    'categories.view_all':  'See full menu',

    'featured.title':       'Most loved',
    'featured.subtitle':    'Customer favourites this week',

    'menu.title':           'Full menu',
    'menu.search':          'Search dishes…',
    'menu.all':             'All',
    'menu.empty_title':     'Menu is being prepared',
    'menu.empty_subtitle':  'Please come back in a moment.',

    'item.add_to_cart':     'Add to cart',
    'item.added':           'Added',
    'item.notes':           'Special requests',
    'item.notes_placeholder':'Allergies, modifications…',

    'cart.title':           'Your order',
    'cart.empty':           'Your cart is empty',
    'cart.empty_sub':       'Tap items to add them to your order.',
    'cart.subtotal':        'Subtotal',
    'cart.total':           'Total',
    'cart.checkout':        'Checkout',
    'cart.clear':           'Clear cart',
    'cart.qty':             'Qty',

    'checkout.title':       'Almost done',
    'checkout.subtitle':    'Tell us where to send it.',
    'checkout.name':        'Your name',
    'checkout.phone':       'Phone (we’ll call if anything changes)',
    'checkout.fulfillment.delivery': 'Delivery',
    'checkout.fulfillment.pickup':   'Pickup',
    'checkout.fulfillment.dine_in':  'Dine-in',
    'checkout.fulfillment.takeaway': 'Takeaway',
    'checkout.address':     'Delivery address',
    'checkout.table':       'Table number',
    'checkout.notes':       'Notes for the kitchen',
    'checkout.place_order': 'Place order',
    'checkout.placing':     'Sending your order…',
    'checkout.failed':      'We couldn’t place your order. Please try again.',

    'track.title':          'Order received',
    'track.subtitle':       'We’re preparing it now.',
    'track.order_number':   'Order number',
    'track.status':         'Status',
    'track.new_order':      'Start a new order',
    'track.step.pending':   'Received',
    'track.step.confirmed': 'Confirmed',
    'track.step.preparing': 'Preparing',
    'track.step.ready':     'Ready',
    'track.step.delivered': 'Delivered',

    'footer.compliance':    'ZATCA-compliant · Made for Saudi Restaurants',
    'footer.powered':       'Powered by',
    'footer.follow':        'Follow us',
    'footer.website':       'Website',
    'footer.rights':        'All rights reserved.',
    'social.instagram':     'Instagram',
    'social.linkedin':      'LinkedIn',
    'social.facebook':      'Facebook',

    'lang.toggle':          'AR',
  },
  ar: {
    'hero.kicker':   'مطعم · اطلب أونلاين',
    'hero.tagline':  'طعام حقيقي يصل بسرعة.',
    'hero.sub.0':    'يُحضّر يدويًا كل يوم.',
    'hero.sub.1':    'التوصيل خلال 25–45 دقيقة.',
    'hero.sub.2':    'جاهز للاستلام خلال 15 دقيقة.',
    'hero.cta.order_delivery': 'اطلب توصيل',
    'hero.cta.order_pickup':   'اطلب استلام',
    'hero.open_now':          'مفتوح الآن',
    'hero.closed':            'مغلق حاليًا',

    'usp.fresh.title':      'طازج دائمًا',
    'usp.fresh.body':       'يُحضَّر عند الطلب — لا ينتظر تحت لمبة التسخين.',
    'usp.delivery.title':   'توصيل سريع',
    'usp.delivery.body':    'السائق ينطلق فور جاهزية طلبك.',
    'usp.secure.title':     'آمن ومُعتمد',
    'usp.secure.body':      'فاتورة إلكترونية متوافقة مع ZATCA المرحلة الثانية.',

    'categories.title':     'تصفّح حسب الفئة',
    'categories.view_all':  'القائمة كاملة',

    'featured.title':       'الأكثر طلبًا',
    'featured.subtitle':    'مفضّلات العملاء هذا الأسبوع',

    'menu.title':           'القائمة',
    'menu.search':          'ابحث عن طبق…',
    'menu.all':             'الكل',
    'menu.empty_title':     'القائمة قيد التحضير',
    'menu.empty_subtitle':  'يُرجى المحاولة بعد قليل.',

    'item.add_to_cart':     'أضِف إلى السلة',
    'item.added':           'تمت الإضافة',
    'item.notes':           'طلبات خاصة',
    'item.notes_placeholder':'حساسية، تعديلات…',

    'cart.title':           'طلبك',
    'cart.empty':           'سلتك فارغة',
    'cart.empty_sub':       'اضغط على الأطباق لإضافتها إلى طلبك.',
    'cart.subtotal':        'المجموع الفرعي',
    'cart.total':           'الإجمالي',
    'cart.checkout':        'إتمام الطلب',
    'cart.clear':           'تفريغ السلة',
    'cart.qty':             'الكمية',

    'checkout.title':       'خطوة أخيرة',
    'checkout.subtitle':    'أخبرنا أين نرسله.',
    'checkout.name':        'اسمك',
    'checkout.phone':       'رقم الجوال (للاتصال عند الحاجة)',
    'checkout.fulfillment.delivery': 'توصيل',
    'checkout.fulfillment.pickup':   'استلام',
    'checkout.fulfillment.dine_in':  'تناول داخل المطعم',
    'checkout.fulfillment.takeaway': 'سفري',
    'checkout.address':     'عنوان التوصيل',
    'checkout.table':       'رقم الطاولة',
    'checkout.notes':       'ملاحظات للمطبخ',
    'checkout.place_order': 'تأكيد الطلب',
    'checkout.placing':     'جارٍ إرسال طلبك…',
    'checkout.failed':      'تعذّر تأكيد طلبك. حاول مرة أخرى.',

    'track.title':          'تم استلام الطلب',
    'track.subtitle':       'نُحضّره الآن.',
    'track.order_number':   'رقم الطلب',
    'track.status':         'الحالة',
    'track.new_order':      'ابدأ طلبًا جديدًا',
    'track.step.pending':   'مستلَم',
    'track.step.confirmed': 'مؤكَّد',
    'track.step.preparing': 'قيد التحضير',
    'track.step.ready':     'جاهز',
    'track.step.delivered': 'تم التوصيل',

    'footer.compliance':    'متوافق مع ZATCA · مصمَّم للمطاعم السعودية',
    'footer.powered':       'مُقدَّم من',
    'footer.follow':        'تابعنا',
    'footer.website':       'الموقع الإلكتروني',
    'footer.rights':        'جميع الحقوق محفوظة.',
    'social.instagram':     'إنستغرام',
    'social.linkedin':      'لينكدإن',
    'social.facebook':      'فيسبوك',

    'lang.toggle':          'EN',
  },
} as const;

type StringKey = keyof typeof STRINGS['en'];

interface Ctx {
  lang: Lang;
  dir: 'ltr' | 'rtl';
  setLang(l: Lang): void;
  toggle(): void;
  t(key: StringKey): string;
}

const LanguageContext = createContext<Ctx | null>(null);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLang] = useState<Lang>(() => {
    const stored = localStorage.getItem('saheeh_customer_lang');
    if (stored === 'ar' || stored === 'en') return stored;
    return (navigator.language || '').toLowerCase().startsWith('ar') ? 'ar' : 'en';
  });

  const dir: 'ltr' | 'rtl' = lang === 'ar' ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
    localStorage.setItem('saheeh_customer_lang', lang);
  }, [lang, dir]);

  const value = useMemo<Ctx>(
    () => ({
      lang,
      dir,
      setLang,
      toggle: () => setLang((l) => (l === 'en' ? 'ar' : 'en')),
      t: (key: StringKey) => STRINGS[lang][key] ?? STRINGS.en[key] ?? key,
    }),
    [lang, dir],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export function useLang(): Ctx {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used inside LanguageProvider');
  return ctx;
}

export function pickLocale<T extends { name: string; name_local: string | null }>(
  item: T,
  lang: Lang,
): string {
  if (lang === 'ar' && item.name_local) return item.name_local;
  return item.name;
}

export function pickDescLocale<T extends { description: string | null; description_local: string | null }>(
  item: T,
  lang: Lang,
): string | null {
  if (lang === 'ar' && item.description_local) return item.description_local;
  return item.description;
}
